"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { ArrowRight, Download, Layout, Map, MousePointerClick, Play, Shield, Smartphone, Video } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
export default function FeaturesLandingPage() {
  const $ = _c(71);
  const [hoveredCard, setHoveredCard] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-[url('/grid-pattern.svg')] opacity-10" />;
    t1 = <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/90 to-slate-800/80" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="inline-flex items-center gap-2 rounded-full bg-slate-800/50 px-3 py-1 text-sm text-slate-300 backdrop-blur border border-slate-700 mb-8"><span className="flex h-2 w-2 rounded-full bg-green-500 animate-pulse" /><span>New: Search by Preference</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-300">The Most Advanced <br /> Real Estate Platform</h1>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto mb-10 leading-relaxed">Experience a seamless journey from discovery to transaction.<br />Built for Buyers. Optimized for Sellers.</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="relative overflow-hidden bg-slate-900 text-white pb-16 md:pb-32 pt-16">{t0}{t1}<div className="container relative mx-auto px-4 text-center">{t2}{t3}{t4}<div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 md:mb-0"><Link href="/features/pdf" target="_blank"><Button size="lg" className="h-12 px-8 text-base bg-white text-slate-900 hover:bg-slate-100 hover:text-white"><Download className="mr-2 h-4 w-4" />Download PDF</Button></Link></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Map className="h-8 w-8 text-blue-500" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = hoveredCard === "search";
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setHoveredCard("search");
    t9 = () => setHoveredCard(null);
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t7) {
    t10 = <FeatureCard icon={t6} title="Dual-Mode Search" description="Toggle between interactive map view with clustering and traditional list view with infinite scroll." hovered={t7} onHover={t8} onLeave={t9} />;
    $[9] = t7;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Layout className="h-8 w-8 text-purple-500" />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = hoveredCard === "filters";
  let t13;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setHoveredCard("filters");
    t14 = () => setHoveredCard(null);
    $[12] = t13;
    $[13] = t14;
  } else {
    t13 = $[12];
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t12) {
    t15 = <FeatureCard icon={t11} title="Comprehensive Filters" description="20+ filter dimensions including budget, BHK, amenities, facing, and possession status." hovered={t12} onHover={t13} onLeave={t14} />;
    $[14] = t12;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <MousePointerClick className="h-8 w-8 text-rose-500" />;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  const t17 = hoveredCard === "negotiation";
  let t18;
  let t19;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setHoveredCard("negotiation");
    t19 = () => setHoveredCard(null);
    $[17] = t18;
    $[18] = t19;
  } else {
    t18 = $[17];
    t19 = $[18];
  }
  let t20;
  if ($[19] !== t17) {
    t20 = <FeatureCard icon={t16} title="Direct Negotiation" description="Make offers, receive counter-offers, and negotiate terms directly through the platform." hovered={t17} onHover={t18} onLeave={t19} />;
    $[19] = t17;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] !== t10 || $[22] !== t15 || $[23] !== t20) {
    t21 = <div className="container mx-auto px-4 pt-8 pb-20 md:-mt-20 md:pt-20 relative z-10"><div className="grid grid-cols-1 md:grid-cols-3 gap-6">{t10}{t15}{t20}</div></div>;
    $[21] = t10;
    $[22] = t15;
    $[23] = t20;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="text-center mb-12"><div className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm text-blue-600 border border-blue-200 mb-4"><Video className="h-4 w-4" /><span>See It In Action</span></div><h2 className="text-3xl font-bold text-slate-900 mb-4">Feature Video Demos</h2><p className="text-slate-600 max-w-2xl mx-auto">Watch quick demos to see how our features work in real-time</p></div>;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  const t23 = hoveredCard === "video1";
  let t24;
  let t25;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = () => setHoveredCard("video1");
    t25 = () => setHoveredCard(null);
    $[26] = t24;
    $[27] = t25;
  } else {
    t24 = $[26];
    t25 = $[27];
  }
  let t26;
  if ($[28] !== t23) {
    t26 = <VideoCard title="Search As You Move" description="Dynamic property search that updates as you pan the map" videoUrl="https://www.youtube.com/shorts/ao3B6VInYOc" hovered={t23} onHover={t24} onLeave={t25} />;
    $[28] = t23;
    $[29] = t26;
  } else {
    t26 = $[29];
  }
  const t27 = hoveredCard === "video2";
  let t28;
  let t29;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => setHoveredCard("video2");
    t29 = () => setHoveredCard(null);
    $[30] = t28;
    $[31] = t29;
  } else {
    t28 = $[30];
    t29 = $[31];
  }
  let t30;
  if ($[32] !== t27) {
    t30 = <VideoCard title="Project Discovery" description="Explore projects with overlay view and detailed information" videoUrl="https://www.youtube.com/shorts/rGW3DSeB3sQ" hovered={t27} onHover={t28} onLeave={t29} />;
    $[32] = t27;
    $[33] = t30;
  } else {
    t30 = $[33];
  }
  const t31 = hoveredCard === "video3";
  let t32;
  let t33;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = () => setHoveredCard("video3");
    t33 = () => setHoveredCard(null);
    $[34] = t32;
    $[35] = t33;
  } else {
    t32 = $[34];
    t33 = $[35];
  }
  let t34;
  if ($[36] !== t31) {
    t34 = <VideoCard title="Search by Preference" description="Save and manage multiple search profiles with carousel navigation" videoUrl="https://www.youtube.com/shorts/qPPXfvDqRkg" hovered={t31} onHover={t32} onLeave={t33} />;
    $[36] = t31;
    $[37] = t34;
  } else {
    t34 = $[37];
  }
  const t35 = hoveredCard === "video4";
  let t36;
  let t37;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = () => setHoveredCard("video4");
    t37 = () => setHoveredCard(null);
    $[38] = t36;
    $[39] = t37;
  } else {
    t36 = $[38];
    t37 = $[39];
  }
  let t38;
  if ($[40] !== t35) {
    t38 = <VideoCard title="Preference Navigation" description="Switch between search preferences with intuitive carousel" videoUrl="https://www.youtube.com/shorts/rGW3DSeB3sQ" hovered={t35} onHover={t36} onLeave={t37} />;
    $[40] = t35;
    $[41] = t38;
  } else {
    t38 = $[41];
  }
  const t39 = hoveredCard === "video5";
  let t40;
  let t41;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = () => setHoveredCard("video5");
    t41 = () => setHoveredCard(null);
    $[42] = t40;
    $[43] = t41;
  } else {
    t40 = $[42];
    t41 = $[43];
  }
  let t42;
  if ($[44] !== t39) {
    t42 = <VideoCard title="Add/Edit Preferences" description="Create and modify search preferences directly from search" videoUrl="https://www.youtube.com/shorts/2ID0T46mngE" hovered={t39} onHover={t40} onLeave={t41} />;
    $[44] = t39;
    $[45] = t42;
  } else {
    t42 = $[45];
  }
  const t43 = hoveredCard === "video6";
  let t44;
  let t45;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = () => setHoveredCard("video6");
    t45 = () => setHoveredCard(null);
    $[46] = t44;
    $[47] = t45;
  } else {
    t44 = $[46];
    t45 = $[47];
  }
  let t46;
  if ($[48] !== t43) {
    t46 = <VideoCard title="Compare Properties" description="Select multiple properties for side-by-side comparison" videoUrl="https://youtube.com/shorts/-9Ew94qTezg" hovered={t43} onHover={t44} onLeave={t45} />;
    $[48] = t43;
    $[49] = t46;
  } else {
    t46 = $[49];
  }
  let t47;
  if ($[50] !== t26 || $[51] !== t30 || $[52] !== t34 || $[53] !== t38 || $[54] !== t42 || $[55] !== t46) {
    t47 = <div className="container mx-auto px-4 sm:px-6 pb-20">{t22}<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6 p-2 max-w-7xl mx-auto">{t26}{t30}{t34}{t38}{t42}{t46}</div></div>;
    $[50] = t26;
    $[51] = t30;
    $[52] = t34;
    $[53] = t38;
    $[54] = t42;
    $[55] = t46;
    $[56] = t47;
  } else {
    t47 = $[56];
  }
  let t48;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <h2 className="text-3xl font-bold text-slate-900 mb-6">Built for every step of your journey</h2>;
    $[57] = t48;
  } else {
    t48 = $[57];
  }
  let t49;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <ListItem title="For Buyers" items={["Schedule visits with instant calendar confirmation", "Track your pipeline: Shortlisted, Visited, Interested", "Masked calling to protect your privacy", "Detailed project analysis and comparison tools"]} />;
    $[58] = t49;
  } else {
    t49 = $[58];
  }
  let t50;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <div className="md:w-1/2">{t48}<div className="space-y-6">{t49}<ListItem title="For Sellers" items={["9-Step listing wizard with map pinning", "Real-time offer dashboard and analytics", "Manage availability slots for visits", "Auto-save drafts and portfolio management"]} /></div></div>;
    $[59] = t50;
  } else {
    t50 = $[59];
  }
  let t51;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <div className="absolute inset-0 bg-blue-100 rounded-full filter blur-3xl opacity-30 animate-blob" />;
    $[60] = t51;
  } else {
    t51 = $[60];
  }
  let t52;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <div className="flex items-center gap-4 mb-8"><div className="h-12 w-12 rounded-full bg-slate-100 flex items-center justify-center"><Shield className="h-6 w-6 text-slate-600" /></div><div><h3 className="font-semibold text-lg">{"Secure & Verified"}</h3><p className="text-slate-500 text-sm">Every interaction is protected</p></div></div>;
    $[61] = t52;
  } else {
    t52 = $[61];
  }
  let t53;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <div className="p-4 rounded-lg bg-slate-50 border border-slate-100 flex items-center gap-3"><Smartphone className="h-5 w-5 text-slate-400" /><span className="text-slate-600">OTP-based Passwordless Login</span></div>;
    $[62] = t53;
  } else {
    t53 = $[62];
  }
  let t54;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <div className="p-4 rounded-lg bg-slate-50 border border-slate-100 flex items-center gap-3"><Shield className="h-5 w-5 text-slate-400" /><span className="text-slate-600">{"Verified Listings & Users"}</span></div>;
    $[63] = t54;
  } else {
    t54 = $[63];
  }
  let t55;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <div className="container mx-auto px-4 pb-24"><div className="flex flex-col md:flex-row gap-16 items-center">{t50}<div className="md:w-1/2 relative">{t51}<div className="border border-slate-200 bg-white rounded-2xl shadow-xl p-8 relative">{t52}<div className="space-y-4">{t53}{t54}<div className="p-4 rounded-lg bg-slate-50 border border-slate-100 flex items-center gap-3"><Layout className="h-5 w-5 text-slate-400" /><span className="text-slate-600">Responsive Mobile-First Design</span></div></div></div></div></div></div>;
    $[64] = t55;
  } else {
    t55 = $[64];
  }
  let t56;
  let t57;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <h2 className="text-3xl font-bold mb-6">Ready to explore?</h2>;
    t57 = <p className="text-slate-400 mb-10 max-w-2xl mx-auto">Download the feature sheet for offline viewing or start searching for your dream home.</p>;
    $[65] = t56;
    $[66] = t57;
  } else {
    t56 = $[65];
    t57 = $[66];
  }
  let t58;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t58 = <div className="bg-slate-900 text-white py-20"><div className="container mx-auto px-4 text-center">{t56}{t57}<Link href="/"><Button className="bg-white text-slate-900 hover:bg-slate-100 px-8 py-6 text-lg rounded-full">Start Searching <ArrowRight className="ml-2 h-5 w-5" /></Button></Link></div></div>;
    $[67] = t58;
  } else {
    t58 = $[67];
  }
  let t59;
  if ($[68] !== t21 || $[69] !== t47) {
    t59 = <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">{t5}{t21}{t47}{t55}{t58}</div>;
    $[68] = t21;
    $[69] = t47;
    $[70] = t59;
  } else {
    t59 = $[70];
  }
  return t59;
}
function FeatureCard(t0) {
  const $ = _c(13);
  const {
    icon,
    title,
    description,
    hovered,
    onHover,
    onLeave
  } = t0;
  const t1 = `bg-white p-8 rounded-2xl shadow-sm border border-slate-200 transition-all duration-300 ${hovered ? "shadow-xl -translate-y-1 border-slate-300" : ""}`;
  let t2;
  if ($[0] !== icon) {
    t2 = <div className="mb-6">{icon}</div>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <h3 className="text-xl font-bold text-slate-900 mb-3">{title}</h3>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = <p className="text-slate-500 leading-relaxed">{description}</p>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onHover || $[7] !== onLeave || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className={t1} onMouseEnter={onHover} onMouseLeave={onLeave}>{t2}{t3}{t4}</div>;
    $[6] = onHover;
    $[7] = onLeave;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}

// Extract video ID from YouTube URL with robust error handling
// Placed at module scope to avoid recreating on every render
const getYouTubeVideoId = (url: string): string | null => {
  try {
    const parsed = new URL(url);
    let id = "";
    if (parsed.hostname === "youtu.be") {
      id = parsed.pathname.slice(1);
    } else if (parsed.pathname.startsWith("/shorts/")) {
      id = parsed.pathname.split("/shorts/")[1];
    } else {
      id = parsed.searchParams.get("v") ?? "";
    }
    return id || null;
  } catch {
    return null;
  }
};
function VideoCard(t0) {
  const $ = _c(20);
  const {
    title,
    description,
    videoUrl,
    hovered,
    onHover,
    onLeave
  } = t0;
  const [isPlayerVisible, setPlayerVisible] = useState(false);
  let t1;
  if ($[0] !== videoUrl) {
    t1 = getYouTubeVideoId(videoUrl);
    $[0] = videoUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const videoId = t1;
  const t2 = `bg-white rounded-2xl shadow-sm border border-slate-200 transition-all duration-300 overflow-hidden ${hovered ? "shadow-xl -translate-y-1 border-blue-300" : ""}`;
  let t3;
  if ($[2] !== isPlayerVisible || $[3] !== title || $[4] !== videoId) {
    t3 = videoId && <div className="relative w-full aspect-[9/16] bg-slate-100">{isPlayerVisible ? <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} title={title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen={true} className="absolute inset-0 w-full h-full" /> : <button onClick={() => setPlayerVisible(true)} className="absolute inset-0 w-full h-full group cursor-pointer" aria-label={`Play ${title}`}><Image src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`} alt={title} fill={true} className="object-cover" unoptimized={true} /><div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" /><div className="absolute inset-0 flex items-center justify-center"><div className="w-16 h-16 rounded-full bg-red-600 group-hover:bg-red-700 transition-all flex items-center justify-center group-hover:scale-110 shadow-lg"><Play className="h-8 w-8 text-white ml-1" fill="white" /></div></div></button>}</div>;
    $[2] = isPlayerVisible;
    $[3] = title;
    $[4] = videoId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center shrink-0"><Video className="h-5 w-5 text-blue-500" /></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== title) {
    t5 = <h3 className="text-lg font-bold text-slate-900 mb-2">{title}</h3>;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== description) {
    t6 = <p className="text-slate-600 text-sm leading-relaxed">{description}</p>;
    $[9] = description;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="p-6"><div className="flex items-start gap-4">{t4}<div className="flex-1">{t5}{t6}</div></div></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onHover || $[15] !== onLeave || $[16] !== t2 || $[17] !== t3 || $[18] !== t7) {
    t8 = <div className={t2} onMouseEnter={onHover} onMouseLeave={onLeave}>{t3}{t7}</div>;
    $[14] = onHover;
    $[15] = onLeave;
    $[16] = t2;
    $[17] = t3;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function ListItem(t0) {
  const $ = _c(9);
  const {
    title,
    items
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h4 className="font-semibold text-blue-600 mb-3 uppercase tracking-wide text-sm">{title}</h4>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <ul className="space-y-3">{t2}</ul>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="mb-6">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(item, i) {
  return <li key={i} className="flex items-start gap-3 text-slate-700"><div className="mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-400 shrink-0" /><span>{item}</span></li>;
}